<template>
  <section class="index-sections index-sections-banner">
    <div class="hero-image-desktop">
      <img src="@/assets/VideoVault.webp" alt="Website Logo" />
    </div>
  </section>
</template>